export default function ContentPage(props: any) {
  return (
    <div>
      <p className="text-center text-xl pb-8 pt-5">{props.title}</p>
      <div className="max-w-3xl px-5 mx-auto mb-8">
        {props.children}
      </div>
    </div>
  )
}